<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
    <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
        <p class="form_sub_title">基础信息</p>
        <a-form-model-item ref="code" v-show="record.code" label="角色编码" prop="code">
            <span class="form_span">{{record.code}}</span>
        </a-form-model-item>
        <a-form-model-item ref="name" label="角色名称" prop="name">
            <a-input
                v-if="is_vue_task"
                v-model="record.name"
                :disabled="disabled"
                    @blur="
                    () => {
                        $refs.name.onFieldBlur();
                    }
                    "
            />
            <span v-else class="form_span">{{record.name}}</span>

        </a-form-model-item>
        <a-form-model-item ref="iseffective" label="有效性" prop="iseffective">
            <a-radio-group v-model="record.iseffective" button-style="solid" style="margin-left:15px"  v-if="is_vue_task">
                <a-radio-button value="1">
                有效
                </a-radio-button>
                <a-radio-button value="0">
                无效
                </a-radio-button>

            </a-radio-group>
             <span v-else class="form_span">{{['无效','有效'][parseInt(record.iseffective)]}}</span>
         </a-form-model-item>

        <a-form-model-item  label="说明" prop="remark">
            <a-input
             v-if="is_vue_task"
                v-model="record.remark"
                :disabled="disabled"
                type="textarea"

            />
            <span v-else class="form_span">{{record.remark}}</span>
        </a-form-model-item>

      

        <p class="form_sub_title">选择对应的功能权限</p>
            <a-tree
                v-model="checkedKeys"
                checkable
                :tree-data="treeData"
                :expanded-keys="expandedKeys"
                :auto-expand-parent="autoExpandParent"
                @select="onSelect"
                @check="onCheck"
                :checkStrictly="checkStrictly"
            >
            </a-tree>
        
      

        <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
            <a-button type="primary" @click="handleOk">
                保存
            </a-button>
            <a-button style="margin-left: 10px;" @click="handleCancel">
                取消
            </a-button>
        </a-form-model-item>
    </a-form-model>


</a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";
const m_title = {
    'addrole':'新增角色',
    'detailrole':'查看角色',
    'editrole':'编辑角色',
};
export default {

    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                name: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],
               
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            c_title:'',
            is_vue_task : true,
            disabled: this.$route.params.action == "detailrole" ? true : false ,
            treeData:[],
            autoExpandParent:true,
            expandedKeys:[],
            checkedKeys: [],
            checkStrictly:true,
        };
    },

    methods: {
        onSelect(){},
        onCheck(){},
        handleOk() {
            let checked_keys = this.checkedKeys
            if(this.checkedKeys.checked){
                checked_keys = this.checkedKeys.checked;
            }
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                    this.record.menus = checked_keys.join(',')
                    if(params.action == 'editrole'){
                        //编辑
                        this.record.id = this.record.id;
                        this.$store
                            .dispatch({
                                type: "rolecenter/updateRole",
                                params: this.record
                            })
                            .then((response) => {
                                console.log(response)
                                this.handleCancel();
                                this.confirmLoading = false;
                            });
                    }
                    else if(params.action == 'addrole'){
                        //新增
                        this.$store
                            .dispatch({
                                type: "rolecenter/addRole",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                    this.confirmLoading = false;
                                }
                                
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        //获取菜单列表
        getMenuTree(selectedmenu){
            this.$store.dispatch({
                type: "rolecenter/getAllMenu",
                showMsg: false
            }).then((res)=>{
                let origin_data = res.data.data;
                //排序
                origin_data.sort(function(a,b){
                    return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
                });
                for (let index = 0; index < origin_data.length; index++) {
                    const element = origin_data[index];
                    element.title = element.name;
                    element.key = element.id;
                    this.expandedKeys.push(element.key)
                    this.handleTreeData(element)
                }

                this.treeData = origin_data
                this.checkedKeys = selectedmenu;
            });
        },
        //递归树结构
        handleTreeData(treeItem){
            treeItem.title = treeItem.name;
            treeItem.key = treeItem.id;
            this.expandedKeys.push(treeItem.key)
            treeItem.children  = [];
            if(treeItem.submenuList.length == 0){
                treeItem.style = 'display:inline;'
            }
            for (let index = 0; index < treeItem.submenuList.length; index++) {
                const r_child = treeItem.submenuList[index];
                treeItem.children.push(this.handleTreeData(r_child)) 

            }
            return treeItem;
        }
    },
    computed: {
        ...mapState("rolecenter", {
            record: function(state) {
                return this.action == "addrole" ? {} : state.record;
            }
        })
    },
    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action]
        if (params.action != "addrole") {
            this.$store.dispatch({
                type: "rolecenter/getRole",
                params: query,
                showMsg: false
            }).then((res)=>{
                let selectmenu = res.data.data.menus.split(',')
                this.getMenuTree(selectmenu);
            })
        }
        else{
            this.$store.dispatch({
                type: "rolecenter/getEmptyRole",
                params: query,
                showMsg: false
            })
            this.getMenuTree([]);

        }

        this.is_vue_task = params.action != 'detailrole'
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.ant-input[disabled]{
    color: rgba(0, 0, 0, 0.55);
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
.form_sub_title{
    font-weight: bold;
}
</style>
